import React from 'react';

const Input = ( props ) => {
    let inputElement = null;
    let errorElement = null;
    let classMain = [
        'form-group'
    ];
    const inputClasses = ['form-control'];

    if (props.invalid && props.shouldValidate && props.touched) {
        classMain.push('has-error');
        errorElement = <span className="help-block">{props.errorMessage}</span>;
    }
    
    switch ( props.elementType ) {
        case ( 'input' ):
            inputElement = <input
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
            break;
        case ( 'text' ):
            inputElement = <input
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
            break;
        case ( 'number' ):
            inputElement = <input
                type="number"
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
            break;
        case ( 'password' ):
            inputElement = <input
                type="password"
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                // value={props.value}
                onChange={props.changed} />;
            break;
        case ( 'date' ):
            inputElement = <input
                type="date"
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
            break;
        case ( 'datetime' ):
            inputElement = <input
                type="text"
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
            break;
        case ( 'textarea' ):
            inputElement = <textarea
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
            break;
        case ( 'select' ):
            inputElement = (
                <select
                    className={inputClasses.join(' ')}
                    value={props.value}
                    onChange={props.changed}>
                    {props.elementConfig.options.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.displayValue}
                        </option>
                    ))}
                </select>
            );
            break;
        case ( 'boolean' ):
            inputElement = (
                <div className="checkbox">
                    <label>
                        <input type="checkbox" onClick={props.changed} defaultChecked={props.value}/>
                        {props.inputName}
                    </label>
                </div>
            );
            break;
        default:
            inputElement = <input
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
    }

    return (
        <div className={classMain.join(' ')}>
            {inputElement}
            {errorElement}
        </div>
    );

};

export default Input;